import { Box, Button, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useCallback, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Webcam from 'react-webcam';
// import { useUploadImageMutation } from '../store/api/userBookingApi';

const WebCamPage = () => {
  const navigate = useNavigate();
  const webcamRef = useRef(null) as any;
  const [imgSrc, setImgSrc] = useState(null) as any;
  const [mirrored, setMirrored] = useState(false);
  // const [uploadImage, uploadImageResponse]=useUploadImageMutation()
  const capture = useCallback(() => {
    const imageSrc = webcamRef?.current?.getScreenshot();
    setImgSrc(imageSrc);
  }, [webcamRef]);
  const retake = () => {
    setImgSrc(null);
  };

  const imageConstraints = {
    // facingMode: { exact: "environment" }
    facingMode: 'user',
  };

  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: '20px',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography variant="h4" gutterBottom>
        Click Photo Of Customer Vehicle
      </Typography>
      <Box style={{ display: 'flex', justifyContent: 'center' }}>
        {imgSrc ? (
          <img
            src={imgSrc}
            alt="webcam"
            style={{ marginTop: '50px', border: '1px solid' }}
            className="qrcodeStyle qrCodeContainerStyle"
          />
        ) : (
          <Webcam
            height={600}
            width={600}
            ref={webcamRef}
            mirrored={mirrored}
            imageSmoothing={true}
            audio={false}
            videoConstraints={imageConstraints}
            screenshotFormat="image/jpeg"
            screenshotQuality={0.8}
            style={{ border: '1px solid' }}
            className="qrcodeStyle qrCodeContainerStyle"
          />
        )}
      </Box>
      <Box style={{ display: 'flex', justifyContent: 'center', flexDirection: 'row' }}>
        {!imgSrc ? (
          <FormControlLabel
            control={<Checkbox name="mirror" checked={mirrored} onChange={(e) => setMirrored(e.target.checked)} />}
            label="Mirror"
          />
        ) : (
          ''
        )}
      </Box>
      <Box style={{ display: 'flex', justifyContent: 'center' }}>
        {imgSrc ? (
          <Box style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
            <Button
              style={{
                color: 'white',
                backgroundColor: '#E23744',
                marginTop: '30px',
              }}
              size="large"
              variant="contained"
              onClick={retake}
            >
              Retake photo
            </Button>
            <Button
              style={{
                color: 'white',
                backgroundColor: '#E23744',
                marginTop: '30px',
              }}
              size="large"
              variant="contained"
              onClick={() => {
                navigate('/dashboard/user-booking');
              }}
            >
              Upload photo
            </Button>
          </Box>
        ) : (
          <Button
            style={{
              color: 'white',
              backgroundColor: '#E23744',
            }}
            size="large"
            variant="contained"
            onClick={capture}
          >
            Capture photo
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default WebCamPage;
